import './CV.css';
import React from 'react';

import CVData from './cvHnn2018v2';
import {
    Header,
    GenericSection,
    SectionWithList,
    WorkHistorySection
} from './CvPresentation';

class CV extends React.Component {

    renderSectionDefault( sectionName, sectionContent ) {
        return( <GenericSection key={sectionName} content={sectionContent} /> );
    }

    renderSectionWithList( sectionName, sectionContent ) {
        return( <SectionWithList key={sectionName} content={sectionContent} /> );
    }

    workHistory( sectionName, sectionContent) {
        return( <WorkHistorySection key={sectionName} content={sectionContent} /> );
    }

    renderSectionList() {

        const {
            sectionList
        } = CVData;

        let idx=0, s = [];

        for(let sectionName in sectionList) {
            switch( sectionName ) {
                case "objective" :
                case "qualifications" :
                    s[idx ++] = this.renderSectionDefault(sectionName, sectionList[sectionName]);
                    break;
                case "interests" :
                case "education" :
                    s[idx ++] = this.renderSectionWithList(sectionName, sectionList[sectionName]);
                    break;
                case "workHistory" :
                    s[idx ++] = this.workHistory(sectionName, sectionList[sectionName]);
                    break;

            }
        }

        return(<div className="cv-main">{s}</div>);


    }


    render () {

        const {
            header
        } = CVData;

        return (
            <div className="cv-wrap">
                <Header content={header} />
                {this.renderSectionList()}
            </div>
        );
    }
}

export default CV;




// WEBPACK FOOTER //
// ./src/components/cv/index.js